import React from "react";
import moment from "moment";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap";
import LineGraph from "./LineGraph";
import TableReading from "./TableReading";
import ReactToPrint from "react-to-print";
import TableReadingPrint from "./TableReadingPrint";
import GraphTableReading from "./GraphTableReading";
import LottieLoader from '../LottieLoader';
import lottieLoaderFile from '../../files/animation/loading.json';
import DisplayCardThreshold from "./DisplayCardThreshold";
import Swal from 'sweetalert2';
export const BodyTraceWSData = ({
  bodytraceWS,
  startDate,
  endDate,
  dateRange,
  onChangeDateRange,
  exportReadingCsv,
  emailReadingReport,
  unitMeasurement,
  profile,
  expectationRule,
  expectationWeightRule,
  notesPatientDetails,
  latestReadingUser,
  rpmTotalDuration,
  ccmTotalDuration,
  ongoingbothReadingRequest,
  ongoingPdfExcelRequest,
  deleteReading
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const printGraph = React.useRef();
  const graphDiv = React.useRef();
  const tableExportRef = React.useRef();
  const printTable = React.useRef();
  const printGraphTableRef = React.useRef();
  // Change date format
  const dateFrom = moment(startDate).startOf('day').clone().format("MMMM DD, YYYY");
  const dateTo = moment(endDate).endOf('day').clone().format("MMMM DD, YYYY");
  const dateFrom1 = moment(startDate).startOf('day').clone().format();
  const dateTo1 = moment(endDate).endOf('day').clone().format();
  // Filter readings type
  const filterReadingType = bodytraceWS.filter(function (value) {
    return moment(value.deviceReadingDate).isBetween(dateFrom1, dateTo1);
  });
  // Order by readings date
  const orderByTheFilter = _.orderBy(
    filterReadingType,
    [
      function (object) {
        return new Date(object.deviceReadingDate);
      }
    ],
    ["asc"]
  );
  // Read array and map out values and device reading date
  const readingValueWithDateTime = _.map(bodytraceWS, function (object) {
    return {
      _id: object._id,
      readingValue: object.values,
      value: [object.values.weight],
      deviceReadingDate: object.deviceReadingDate,
      comments: object.comments,
    };
  });
  const readingValueWithDate = _.orderBy(readingValueWithDateTime, [(obj) => new Date(obj.deviceReadingDate)], ['asc'])
  // Order by reading date filter
  const readingDate = _.map(orderByTheFilter, function (value, index) {
    return moment(value.deviceReadingDate).format("MMMM DD, YYYY hh:mm a");
  });
  
  let readingDataSet = [];
  let readingThreshold = [];
  const subType = ["weight"];
  const subTypeColor = ["#569a45"];
  _.map(subType, function (v, i) {
    const matchingExpectationsBreached = _.filter(expectationRule, function (o) {
      return (
          o && o.readingSubType.toLowerCase() == v.toLowerCase() &&
          !o.name.toLowerCase().includes("Event".toLowerCase())
        );
      }
    );
    const matchingExpectationsWeightBreached = _.filter(expectationWeightRule,function (o) {
      return (
        o && !o.name.toLowerCase().includes("Event".toLowerCase())
      );
      }
    );
    // Checked all of the readings to see which had a low threshold.
    var lowExpectation = _.flatMap(_(matchingExpectationsBreached)
      .filter((o) => o && o.condition == "<=" || o.condition == "between")
      .flatMap((_value, i) => _.pick(_value, "valueProperty"))
      .value(), "valueProperty");

    var highExpectation = _.flatMap(_(matchingExpectationsBreached)
      .filter((o) => o && o.condition == ">=" || o.condition == "between")
      .flatMap((_value, i) => _.pick(_value, "valueProperty"))
      .value(), "valueProperty");

    var lowValueThreshold = _.maxBy(_.map(lowExpectation, i => i.minValue || i.value), function(o) { return o && parseInt(o) });
    var highValueThreshold = _.minBy(_.map(highExpectation, i => i.maxValue || i.value), function(o) { return o && parseInt(o) }); 
    if (matchingExpectationsWeightBreached && _.size(matchingExpectationsWeightBreached) > 0) {
      const weightGain = _.max(_.map(matchingExpectationsWeightBreached, model => model.gainLossPerDay));
      readingThreshold.push({
        lowThreshold: lowValueThreshold,
        highThreshold: highValueThreshold,
        isWeight: true,
        weightGain: weightGain,
        readingSubTypeName: "Weight"
      });
    } else {
      if (v.name != "BMI") {
        readingThreshold.push({
          lowThreshold: lowValueThreshold,
          highThreshold: highValueThreshold,
          readingSubTypeName: "Weight"
        });
      }
    }
    const lowValue = lowValueThreshold ? lowValueThreshold : 0;
    const highValue = highValueThreshold ? highValueThreshold : 0;

    if (lowValue > 0) {
      const lowExpectations = _.map(readingValueWithDate, function (rawvalue, index) {
        return { y: Math.round(lowValue) };
      });
      readingDataSet.push({
        label: `Low (${v})`,
        fill: false,
        radius: 2,
        pointRadius: 1,
        pointHoverRadius: 1,
        stepped: false,
        borderWidth: 2,
        borderDash: [2],
        pointStyle: 'rectRot',
        borderColor: subTypeColor[i],
        pointBackgroundColor: "transparent",
        data: lowExpectations
      });
    }
    if (highValue > 0) {
      const highExpectations = _.map(readingValueWithDate, function (_rawvalue) {
        return { y: Math.round(highValue) };
      });
      readingDataSet.push({
        label: `High (${v})`,
        fill: false,
        radius: 2,
        pointRadius: 1,
        pointHoverRadius: 1,
        stepped: false,
        pointStyle: 'rectRot',
        pointRadius: 2,
        borderWidth: 2,
        borderDash: [5, 2],
        borderColor: subTypeColor[i],
        pointBackgroundColor: "transparent",
        data: highExpectations
      });
    }
    const newReading = _.map(readingValueWithDate, function (rawvalue, index) {
      return { y: rawvalue.readingValue[v] };
    });
    // Dataset for chart
    readingDataSet.push({
      label: v,
      fill: false,
      pointRadius: 4,
      pointHoverRadius: 4,
      backgroundColor: "#ff0000",
      pointRadius: 5,
      pointHoverRadius: 5,
      borderColor: subTypeColor[i],
      pointBackgroundColor: subTypeColor[i],
      data: newReading
    });
  });

  const bDateFrom = moment(dateFrom).clone().format("MMMM DD, YYYY");
  const bDateTo = moment(dateTo)
    .clone()
    .subtract(1, "d")
    .format("MMMM DD, YYYY");

  const weightScaleSubTypes = [
    {
      _id: "5be56d0b3863cd0647d79898",
      name: "Weight",
      unit: "lb",
      color: "#569a45"
    }
  ];
  const readingType = {
    _id: "633c2628ebfa2e7e9022fab3",
    abbrev: "BT_WS",
    description: "Bodytrace Weight Scale"
  };
  
  return (
    <Col sm="6" className="mt-4">
      <Card className="card-design" style={{ backgroundColor: "#fffff" }}>
        <CardBody className="line-graph-card-padding">
          <div className="card-title row align-items-center">
            <div className="col-9">
              <div>
                <div className="text-left reading-card-for-all-reading">
                  <img
                    src={require(`../../files/Reading/BT_WS.svg`)}
                    alt="profile-image"
                    className="profile rounded-circle img-fluid mr-2 reading-icon"
                  /> <div className="min-width-0">
                    <h4 className="reading-card-title mb-0">BodyTrace Weight Scale</h4>
                    <h6 className="reading-card-subtitle">{`${dateFrom} - ${dateTo}`}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 d-flex justify-content-md-end justify-content-start mt-2 mb-md-4">
              <a
                target="_blank"
                onClick={() => setShowModal(!showModal)}
                className="btn btn-sm display-chart-show-more"
              >
                Show More Details
              </a>
            </div>
          </div>
          <LineGraph
            readingDate={readingDate}
            readingDataSet={readingDataSet}
            hidePrint="d-none"
            dontRender="true"
            title={`(${dateFrom} - ${dateTo})`}
            isWeightChart={true}
            unit="lbs"
          />
          <div />
        </CardBody>
        <DisplayCardThreshold
          readingThreshold={readingThreshold}
        />
      </Card>
      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        className="modal-lg modal-dialog-centered"
        style={{ maxWidth: "77%" }}
      >
        <ModalHeader className="close_button" toggle={() => setShowModal(!showModal)}>
          <Label className="align-items-center justify-content-center text-center">BodyTrace Weight Scale</Label>
          <button
            className="btn btn-info ml-2 reading-report-email"
            style={{ float: 'right' }}
            onClick={async () => {
              const { value: email } = await Swal.fire({
                title: "Reading Report!",
                input: "email",
                inputLabel: "Your email address",
                inputPlaceholder: "Enter your email address",
                confirmButtonText: 'Sent',
                showCancelButton: false,
              });
              if (email) {
                emailReadingReport(readingType._id, false, true, email, undefined, startDate, endDate);
              }
            }}>
            <i className="mdi mdi-email" style={{
              fontSize: 20
            }}></i>
            Email
          </button>
          <ReactToPrint
            trigger={() => (
            <div className="pull-right">
              <button
                  className="btn btn-info ml-2 print-click-cls"
                  style={{ float: 'right' }}>
                  <i className="mdi mdi-cloud-print" style={{
                    fontSize: 20
                  }}></i>
                  Print Graph
                </button>
              </div>
            )}                                      
            content={() => graphDiv.current}
            onBeforePrint={() => {
              document.title = `Remote Patient Monitoring Vitals Graph (${profile.fname} ${profile.lname})`;
            }}
            onAfterPrint={() => {
              document.title = "MYVITALVIEW";
            }}
          />
          <ReactToPrint
            trigger={() => (
              <div className="pull-right">
                <button
                  className="btn btn-info ml-2 print-data-table-click-cls"
                  style={{ float: 'right' }}>
                  <i className="mdi mdi-cloud-print" style={{
                    fontSize: 20
                  }}></i>
                  Print Logbook
                </button>
              </div>
            )}
            content={() => printTable.current}
            onBeforePrint={() => {
              document.title = `Remote Patient Monitoring Electronic Logbook Report (${profile.fname} ${profile.lname})`;
            }}
            onAfterPrint={() => {
              document.title = "MYVITALVIEW";
            }}
          />
           <ReactToPrint
              trigger={() => (
              <div className="pull-right">
                <button
                    className="btn btn-info ml-2 print-whole-data-table-click-cls"
                    style={{ float: 'right' }}>
                    <i className="mdi mdi-cloud-print" style={{
                      fontSize: 20
                    }}
                    ></i>
                    Print Graph & Logs
                  </button>
                </div>
              )}                                      
              content={() => printGraphTableRef.current}
              onBeforePrint={() => {
                document.title = `Remote Patient Monitoring Vitals Graph and Electronic Logbook Report (${profile.fname} ${profile.lname})`;
              }}
              onAfterPrint={() => {
                document.title = "MYVITALVIEW";
              }}
            />
          {/* <button
              className="btn btn-info ml-3 print-graph-table-click-cls"
              style={{ float: 'right' }}
              onClick={() => {
                                                        
              }}
            >
              <i className="mdi mdi-cloud-print" style={{
                fontSize: 20
              }}></i>
              Print Graph & Reading
            </button> */}

          <button
            className="btn btn-info ml-2 download-click-cls"
            style={{ float: 'right' }}
            onClick={() => exportReadingCsv(readingType._id,false,true)}
          >
            <i className="mdi mdi-download" style={{
              fontSize: 20
            }}></i>
            Export CSV
          </button>
          <button
            style={{ float: 'right' }}
            onClick={() => {
              setShowModal(!showModal)
            }}
            className="btn btn-info ml-2 close-click-cls"
          >
            <i className="mdi mdi-close" style={{
              fontSize: 20
            }}></i>
            Close
          </button>
        </ModalHeader>
        <ModalBody style={{ backgroundColor: "white" }}>
          <div className="text-center">
            <select
              name="dateRange"
              className="date-range-option"
              value={dateRange}
              onChange={onChangeDateRange}
            >
              <option value="7">7 Days</option>
              <option value="1">1 Month</option>
              <option value="6">6 Months</option>
              <option value="custom">Custom Date</option>
            </select>
          </div>
          <div
            className={`text-center col-md-6 mx-auto ${dateRange !== "custom" ? "d-none" : ""
              }`}
          >
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Start Date</Label>
                  <Input
                    className="input-date-filter"
                    type="date"
                    name="startDate"
                    onChange={onChangeDateRange}
                    value={startDate}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="examplePassword">End Date</Label>
                  <Input
                    className="input-date-filter"
                    type="date"
                    name="endDate"
                    onChange={onChangeDateRange}
                    value={endDate}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
          {(ongoingbothReadingRequest || ongoingPdfExcelRequest) && (
            <LottieLoader
            loadLoop={true}
            autoplayLoop={true}
            source={lottieLoaderFile}
            Lheight={150}
            Lwidth={150}
            subTitle={"Please Wait ..."}
          />
          )}
           {(!ongoingbothReadingRequest && !ongoingPdfExcelRequest) && (
            <>
          <LineGraph
            ref={printGraph}
            readingDate={readingDate}
            readingDataSet={readingDataSet}
            title={`(${dateFrom} - ${dateTo})`}
            isWeightChart={true}
            unit="lbs"
          />
          <hr></hr>
          <DisplayCardThreshold
            isHideBorder={true}
            leftAline={true}
            readingThreshold={readingThreshold}
          />
          <TableReading
            ref={tableExportRef}
            reading={readingValueWithDate}
            subType={weightScaleSubTypes}
            readingValue={_.map(readingValueWithDate, "value")}
            unitMeasurement={unitMeasurement}
            date={`(${bDateFrom} - ${bDateTo})`}
            fname={profile.fname}
            lname={profile.lname}
            bodyTraceWS={true}
            deleteReading={deleteReading}
          />
          </>
           )}
          <div className="hideChart">
            <GraphTableReading
              ref={printGraphTableRef}
              readingDate={readingDate}
              readingThreshold={readingThreshold}
              readingDataSet={readingDataSet}
              readingType={readingType}
              reading={readingValueWithDate}
              subType={weightScaleSubTypes}
              readingValue={_.map(readingValueWithDate, "value")}
              unitMeasurement={unitMeasurement}
              startDate={bDateFrom}
              endDate={bDateTo}
              date={`(${bDateFrom} - ${bDateTo})`}
              fname={profile.fname}
              lname={profile.lname}
              notesPatientDetails={notesPatientDetails}
              latestReadingUser={latestReadingUser}
              ccmTotalDuration = {ccmTotalDuration}
              rpmTotalDuration = {rpmTotalDuration}
              callingThroughValue = 'graphlogbook'
              bodyTraceWS={true}
              isWeightChart={true}
              unit={unitMeasurement.umWeight}
            />
          </div>
          <div className="hideChart">
            <GraphTableReading
              ref={graphDiv}
              readingDate={readingDate}
              readingThreshold={readingThreshold}
              readingDataSet={readingDataSet}
              readingType={readingType}
              reading={readingValueWithDate}
              subType={weightScaleSubTypes}
              readingValue={_.map(readingValueWithDate, "value")}
              unitMeasurement={unitMeasurement}
              startDate={bDateFrom}
              endDate={bDateTo}
              date={`(${bDateFrom} - ${bDateTo})`}
              fname={profile.fname}
              lname={profile.lname}
              notesPatientDetails={notesPatientDetails}
              latestReadingUser={latestReadingUser}
              ccmTotalDuration = {ccmTotalDuration}
              rpmTotalDuration = {rpmTotalDuration}
              callingThroughValue = 'graph'
              bodyTraceWS={true}
              isWeightChart={true}
              unit={unitMeasurement.umWeight}
            />
          </div>
          <div className="hideChart">
            <GraphTableReading
              ref={printTable}
              readingDate={readingDate}
              readingThreshold={readingThreshold}
              readingDataSet={readingDataSet}
              readingType={readingType}
              reading={readingValueWithDate}
              subType={weightScaleSubTypes}
              readingValue={_.map(readingValueWithDate, "value")}
              unitMeasurement={unitMeasurement}
              startDate={bDateFrom}
              endDate={bDateTo}
              date={`(${bDateFrom} - ${bDateTo})`}
              fname={profile.fname}
              lname={profile.lname}
              notesPatientDetails={notesPatientDetails}
              latestReadingUser={latestReadingUser}
              ccmTotalDuration = {ccmTotalDuration}
              rpmTotalDuration = {rpmTotalDuration}
              callingThroughValue = 'logbook'
              bodyTraceWS={true}
              isWeightChart={true}
              unit={unitMeasurement.umWeight}
            />
          </div>
        </ModalBody>
      </Modal>
    </Col>
  );
};
